import { useState, useRef } from "react";
import { toast } from "react-toastify";
import jsQR from "jsqr";

import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "./SearchToggle.css";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import BasicDatePicker from "./Date-picker";
import Loader from "./Loader";
import capitalzer from "../util/capitalize";
import {
  calculateAgeInMonths,
  caluclateGestationalAgeInDays,
  getDateAndYear,
} from "../helper/getAge";

const SearchToggle = ({ pediatricianId }) => {
  // State variables
  const [searchResults, setSearchResults] = useState(""); // To display search result messages
  const [patientData, setPatientData] = useState([]); // List of patients fetched from the API
  const [firstName, setFirstName] = useState(""); // Input field for patient's first name
  const [lastName, setLastName] = useState(""); // Input field for patient's last name
  const [dob, setDob] = useState(null); // Date of birth input managed as a Date object
  const [selectedPatient, setSelectedPatient] = useState(null); // Holds selected patient for viewing profile
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("s2stoken");

  const fileInputRef = useRef(null); // Ref for hidden file input (QR upload)

  // Handle QR code scan

  // const handleQrScan = async (file) => {
  //   let encrypted_id;
  //   const img = new Image();
  //   img.src = URL.createObjectURL(file);

  //   img.onload = async () => {
  //     const canvas = document.createElement("canvas");
  //     const ctx = canvas.getContext("2d");
  //     canvas.width = img.width;
  //     canvas.height = img.height;

  //     // Draw image on the canvas
  //     ctx.drawImage(img, 0, 0);

  //     // Extract image data
  //     const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  //     // Decode QR Code
  //     const code = jsQR(imageData.data, imageData.width, imageData.height);
  //     if (code) {
  //       encrypted_id = code.data;
  //       console.log("QR Code Data:", code.data);

  //       try {
  //         if (encrypted_id === undefined) {
  //           setSearchResults("No Valid Qr Code Found");
  //           return new Error("No QR Code found.");
  //         }

  //         const payload = {
  //           encrypted_id: encrypted_id
  //         };

  //         const response = await fetch(
  //           `${process.env.REACT_APP_BACKEND_URL}/api/get_patient_by_qr_code_doctor`,
  //           {
  //             method: "POST", // Change to POST as GET requests do not have a body
  //             headers: {
  //               "Content-Type": "application/json"
  //             },
  //             body: JSON.stringify(payload),
  //             credentials: "include"
  //           }
  //         );

  //         if (!response.ok) {
  //           throw new Error(
  //             `Error fetching patient data: ${response.statusText}`
  //           );
  //         }

  //         const data = await response.json();
  //         const patients = data.patients || [];
  //         console.log("Data", data);
  //         console.log("Patients from the backend:", patients);

  //         // Filter for matching patients

  //         if (patients.length > 0) {
  //           const patientDetails = patients.map((patient) => ({
  //             patientId : patient.patient_id,
  //             patientFirstName: patient.patient_first_name,
  //             patientLastName: patient.patient_last_name,
  //             date_of_birth:   calculateAgeInMonths(patient.date_of_birth) === 0
  //             ? ` ${caluclateAgeinDays(patient.date_of_birth)} days `
  //             : `${calculateAgeInMonths(patient.date_of_birth)} months`,
  //             caregiverFirstName: patient.caregiver_first_name,
  //             caregiverLastName: patient.caregiver_last_name
  //           }));
  //           setPatientData(patientDetails);
  //           setSearchResults("");
  //         } else {
  //           setSearchResults("No results found.");
  //           setPatientData([]);
  //         }
  //       } catch (error) {
  //         console.log("Error fetching patient data:", error);
  //       }
  //     } else {
  //       console.log("No QR Code found.");
  //     }
  //   };
  // };

  const handleQrScan = async (file) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    setPatientData([]);
    setSearchResults("");
    img.onload = async () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;

      // Draw image on the canvas
      ctx.drawImage(img, 0, 0);

      // Extract image data
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

      // Decode QR Code
      const code = jsQR(imageData.data, imageData.width, imageData.height);
      if (code) {
        const encrypted_id = code.data;
        console.log("QR Code Data:", encrypted_id);

        try {
          const payload = {
            encrypted_id: encrypted_id,
            docId: pediatricianId,
          };
          setLoading(true);
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/get_patient_by_qr_code_doctor`,
            {
              method: "POST", // Use POST for sending data
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(payload),
              credentials: "include",
            }
          );
          console.log(response);
          if (response.status === 403) {
            return setSearchResults(
              "Not authorized to access this patient. Please search another patient."
            );
          }
          if (response.status === 404) {
            return setSearchResults("Patient Not Found");
          }
          if (response.status === 400) {
            return setSearchResults("Invalid QR CODE");
          }
          const data = await response.json();
          if (!response.ok || data.success === false) {
            setLoading(false);
            throw new Error(data.message || "Failed to fetch data");
          }
          setLoading(false);
          const patients = data.patients || [];
          console.log("Patients from the backend:", patients);

          if (patients.length > 0) {
            const patientDetails = patients.map((patient) => {
              const actualAge = caluclateAgeinDays(patient.date_of_birth);
              const actualAgeInMonths = calculateAgeInMonths(
                patient?.date_of_birth
              );
              const calculateAgeInDays = caluclateGestationalAgeInDays(
                patient?.date_of_birth,
                patient?.edd
              );
              let gest_age_days_weeks = "";
              let gest_age_months_weeks = "";
              let gestationalAgeInMonths = "";
              let gestationalAgeInDays = "";
              if (actualAgeInMonths <= 24) {
                const eddAgeIndays = caluclateAgeinDays(patient?.edd);
                const diffWeeks = eddAgeIndays
                  ? Math.round((eddAgeIndays - actualAge) / 7)
                  : "";
                const gestWeeks = 40 + diffWeeks;
                const gestMonthsDiff = Math.floor((40 - gestWeeks) / 4);
                const gestMonths = actualAgeInMonths - gestMonthsDiff;
                if (patient?.edd) {
                  gestationalAgeInMonths =
                    gestWeeks < 37 ? gestMonths : actualAgeInMonths;
                  const calcGestationalAgeDays =
                    getDateAndYear(patient?.date_of_birth) ===
                    getDateAndYear(patient?.edd)
                      ? actualAge
                      : calculateAgeInDays !== 0
                      ? actualAge - calculateAgeInDays
                      : 0;
                  gestationalAgeInDays =
                    gestWeeks < 37 ? calcGestationalAgeDays : actualAge;
                } else if (!patient?.edd && patient?.gestational_age) {
                  const adjustedAge =
                    actualAge - Math.round((40 - patient?.gestational_age) * 7);
                  const gestMonthDiff = Math.floor(
                    (40 - Number(patient?.gestational_age)) / 4
                  );
                  const adjustedAgeMonths = actualAgeInMonths - gestMonthDiff;
                  gest_age_days_weeks =
                    patient?.gestational_age < 37 ? adjustedAge : actualAge;
                  gest_age_months_weeks =
                    patient?.gestational_age < 37
                      ? adjustedAgeMonths
                      : actualAgeInMonths;
                }
              }
              return {
                patientId: patient.patient_id,
                patientFirstName: patient.patient_first_name,
                patientLastName: patient.patient_last_name,
                date_of_birth:
                  calculateAgeInMonths(patient.date_of_birth) === 0
                    ? ` ${caluclateAgeinDays(patient.date_of_birth)} Days `
                    : `${calculateAgeInMonths(patient.date_of_birth)} Months`,
                caregiverFirstName: patient.caregiver_first_name,
                caregiverLastName: patient.caregiver_last_name,
                patient_ai_health_summary: patient.patient_ai_health_summary,
                dob: patient.date_of_birth,
                gestationalAgeInDays: patient?.edd
                  ? gestationalAgeInDays
                  : gest_age_days_weeks,
                gestationalAgeInMonths: patient?.edd
                  ? gestationalAgeInMonths
                  : gest_age_months_weeks,
              };
            });
            setPatientData(patientDetails);
            setSearchResults("");
          } else {
            setLoading(false);
            setSearchResults(
              "Patient not found. Please upload correct QR code for the patient."
            );
            setPatientData([]);
          }
        } catch (error) {
          setLoading(false);
          if (error?.response?.data?.message === "Token has expired") {
            localStorage.removeItem("s2stoken");
            navigate("/");
          }
          setSearchResults(
            "Patient not found. Please upload correct QR code for the patient."
          );
          console.error("Error fetching patient data:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
        console.log("No QR Code found.");
        setSearchResults("No Valid QR Code Found");
      }
    };
  };

  // Handle the search operation
  const handleSearch = async () => {
    if (!firstName || !lastName || !dob) {
      toast.error("Please fill in all required fields!");
      return;
    }

    try {
      // Create the payload as JSON
      const payload = {
        first_name: firstName.toLowerCase().trim(),
        last_name: lastName.toLowerCase().trim(),
        docId: pediatricianId,
        date_of_birth: new Date(dob).toLocaleDateString("en-CA"), // Send the date in 'YYYY-MM-DD' format
      };
      setPatientData([]);
      setSearchResults("");
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/get_patient_for_doctor`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
          credentials: "include",
        }
      );

      if (response.status === 403) {
        return setSearchResults(
          "Not authorized to access this patient. Please search another patient."
        );
      }
      if (response.status === 404) {
        return setSearchResults("Patient Not Found");
      }
      const data = await response.json();
      if (!response.ok || data.success === false) {
        throw new Error(data.message || "Failed to fetch data")
      }

      const patients = data.patients || [];
      console.log("Data", data);
      console.log("Patients from the backend:", patients);

      // Filter for matching patients
      const matchingPatients = patients.filter(
        (patient) =>
          patient.patient_first_name.toLowerCase() ===
            firstName.toLowerCase() &&
          patient.patient_last_name.toLowerCase() === lastName.toLowerCase() &&
          patient.date_of_birth === new Date(dob).toLocaleDateString("en-CA")
      );

      if (patients.length > 0) {
        const patientDetails = patients.map((patient) => {
          const actualAge = caluclateAgeinDays(patient.date_of_birth);
          const actualAgeInMonths = calculateAgeInMonths(
            patient?.date_of_birth
          );
          const calculateAgeInDays = caluclateGestationalAgeInDays(
            patient?.date_of_birth,
            patient?.edd
          );
          let gest_age_days_weeks = "";
          let gest_age_months_weeks = "";
          let gestationalAgeInMonths = "";
          let gestationalAgeInDays = "";
          if (actualAgeInMonths <= 24) {
            const eddAgeIndays = caluclateAgeinDays(patient?.edd);
            const diffWeeks = eddAgeIndays
              ? Math.round((eddAgeIndays - actualAge) / 7)
              : "";
            const gestWeeks = 40 + diffWeeks;
            const gestMonthsDiff = Math.floor((40 - gestWeeks) / 4);
            const gestMonths = actualAgeInMonths - gestMonthsDiff;
            if (patient?.edd) {
              gestationalAgeInMonths =
                gestWeeks < 37 ? gestMonths : actualAgeInMonths;
              const calcGestationalAgeDays =
                getDateAndYear(patient?.date_of_birth) ===
                getDateAndYear(patient?.edd)
                  ? actualAge
                  : calculateAgeInDays !== 0
                  ? actualAge - calculateAgeInDays
                  : 0;
              gestationalAgeInDays =
                gestWeeks > 37 ? calcGestationalAgeDays : actualAge;
            } else if (!patient?.edd && patient?.gestational_age) {
              const adjustedAge =
                actualAge - Math.round((40 - patient?.gestational_age) * 7);
              const gestMonthDiff = Math.floor(
                (40 - Number(patient?.gestational_age)) / 4
              );
              const adjustedAgeMonths = actualAgeInMonths - gestMonthDiff;
              gest_age_days_weeks =
                patient?.gestational_age < 37 ? adjustedAge : actualAge;
              gest_age_months_weeks =
                patient?.gestational_age < 37
                  ? adjustedAgeMonths
                  : actualAgeInMonths;
            }
          }
          return {
            patientId: patient.patient_id,
            patientFirstName: patient.patient_first_name,
            patientLastName: patient.patient_last_name,
            date_of_birth:
              calculateAgeInMonths(patient.date_of_birth) === 0
                ? ` ${caluclateAgeinDays(patient.date_of_birth)} Days `
                : `${calculateAgeInMonths(patient.date_of_birth)} Months`,
            caregiverFirstName: patient.caregiver_first_name,
            caregiverLastName: patient.caregiver_last_name,
            patient_ai_health_summary: patient.patient_ai_health_summary,
            dob: patient.date_of_birth,
            gestationalAgeInMonths: patient?.edd
              ? gestationalAgeInMonths
              : gest_age_months_weeks,
            gestationalAgeInDays: patient?.edd
              ? gestationalAgeInDays
              : gest_age_days_weeks,
          };
        });
        setPatientData(patientDetails);
        setSearchResults("");
      } else {
        setSearchResults("No results found.");
        setPatientData([]);
      }
    } catch (error) {
      if (error?.response?.data?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
      console.error("Error fetching patient data:", error);
      toast.error("Failed to fetch patient data.");
    } finally {
      setFirstName("");
      setLastName("");
      setDob(null);
      setLoading(false);
    }
  };

  //? Calculate age in days
  const caluclateAgeinDays = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    const diffTime = Math.abs(today - birthDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  let navigate = useNavigate();

  // Handle patient click
  const handlePatientClick = (patient) => {
    navigate(`/new-patient-profile/${patient.patientId}/${pediatricianId}`);
    setSelectedPatient(patient); // Set selected patient
  };

  return (
    <div className="search-wrapper">
      <div className="search-container">
        <TextField
          type="text"
          variant="outlined"
          label="Patient First Name"
          // className="search-input"
          value={firstName}
          required
          onChange={(e) => setFirstName(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              height: "50px",
              borderRadius: "8px",
            },
            backgroundColor: "white",
          }}
        />
        <TextField
          type="text"
          label="Patient Last Name"
          variant="outlined"
          // className="search-input"
          value={lastName}
          required
          onChange={(e) => setLastName(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              height: "50px",
              borderRadius: "8px",
            },
            backgroundColor: "white",
          }}
        />
        <div className="date-input-container">
          <BasicDatePicker
            label={"Date of birth"}
            value={dob}
            onChange={(date) => setDob(date)}
            required
            maxDate
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              height: "50px",
            }}
            sx={{
              "& .MuiFormLabel-root": {
                lineHeight: "1.1m",
                overflow: "inherit",
              },
              "& .MuiInputLabel-shrink": {
                transform: "translate(14px, -10px) scale(0.85)",
              },
            }}
          />
        </div>
      </div>
      <button onClick={handleSearch} className="search-button">
        SEARCH
      </button>

      <h4 className="or">OR</h4>

      <button
        onClick={() => fileInputRef.current.click()}
        className="upload-button"
      >
        Upload QR
      </button>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/*"
        onChange={(e) => {
          console.log("File uploaded:", e.target.files[0]);
          handleQrScan(e.target.files[0]);
          e.target.value = ""; // Reset the input field after upload
        }}
      />
      {searchResults && (
        <p style={{ color: "red", fontSize: "18px" }}>{searchResults}</p>
      )}
      <div className="search-loader-container">
        <Loader isLoading={loading} />
      </div>
      {patientData.length > 0 && (
        <div className="search-results">
          <h3 className="search-result-label">Search Results</h3>

          {patientData.map((patient, index) => (
            <div
              key={index}
              className="patient-info-container"
              onClick={() => handlePatientClick(patient)}
            >
              <div className="patient-info">
                <div className="info-row">
                  <div className="info-item">
                    <p>Patient First Name:</p>
                    <span>{capitalzer(patient.patientFirstName)}</span>
                  </div>
                  <div className="info-item">
                    <p>Patient Last Name:</p>
                    <span>
                      {/* {'patient'} */}
                      {capitalzer(patient.patientLastName)}
                    </span>
                  </div>
                </div>

                <div className="info-row">
                  <div className="info-item">
                    <p>Caregiver First Name:</p>
                    <span>
                      {/* {'patientLastName'} */}
                      {capitalzer(patient.caregiverFirstName)}
                    </span>
                  </div>
                  <div className="info-item">
                    <p>Caregiver Last Name:</p>
                    <span>
                      {/* {'patient'} */}
                      {capitalzer(patient.caregiverLastName)}
                    </span>
                  </div>
                </div>

                <div className="info-row">
                  <div className="info-item">
                    <p>Actual Age :</p>
                    <span>
                      {/* {'patient'} */}
                      {patient.date_of_birth}
                    </span>
                  </div>
                  {patient?.date_of_birth.split(" ")[0] <= 24 && (
                    <div className="info-item">
                      <p>Adjusted Age :</p>
                      <span>
                        {patient?.gestationalAgeInDays !== ""
                          ? patient?.gestationalAgeInMonths === 0
                            ? patient.gestationalAgeInDays + " Days"
                            : patient?.gestationalAgeInMonths + " Months"
                          : "N/A"}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <button className="navigate-patientprofile">
                Go To Patient Profile
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchToggle;
